export default __webpack_public_path__ + "static/media/tuat.e492f96c.png";